module.exports = __webpack_public_path__ + "static/media/33.5f8f833c.jpeg";